import { DataGrid } from "@mui/x-data-grid";
import {
  CmpTypographyField,
  CmpDatePickerField,
  CmpSelectField,
  CmpSelectArrField,
  CmpInputField,
  CmpCheckboxField,
} from "../../../Component/Common/ToolBox/ToolBox";
import { hasValueInErrorMessage } from "../../../Utility/Utilitys";

import Grid from "@mui/material/Grid";
import GCToggleSearch from "../../../Component/Common/ReuseableComponent/GCToggleSearch"; 
import {
  CmpDatePickerField001V1,
  CmpSelectFieldV1,
  CmpTextFieldV1,
} from "../../../Component/Common/ToolBox/ToolBoxV1";
import GCToggleSearchV1 from "../../../Component/Common/ReuseableComponent/GCToggleSearchV1";
export default function GCHead({
  vMediaQuery,
  //grid saleshistory end
  vRdxWmsHead,
  sDocLoadingGrnType,
  
  sTransferType,
  fonSelectedGrnType,
 
  fInvDate,
  fPostDt,
  
  fTransferType,
  fFromLocation,
  fToLocation,
  
  xKey,
  
  sFromLocation,
  sToLocation,
  xErrorMsg,
  xDisableBasedOnGridDataLength,
  
  sBufferItmCd,
  headGridShow,
  sHeadGridColumn,
  sHeadGridRow,
   
}) {
  return (
    <form id="Head">
      <Grid
        container
        rowSpacing={{ xs: 0.9, sm: 0.9, md: 0 }}
        columnSpacing={{ xs: 0, sm: 0.9, md: 1 }}
        columns={{ xs: 12, sm: 12, md: 12, lg: 12 }}
      >
        <Grid
          item
          xs={12}
          sm={12}
          md={5}
          lg={5}
          className={vMediaQuery ? "" : "pe-5"}
        >
          <Grid
            container
            spacing={0.9}
            columns={{ xs: 12, sm: 12, md: 12 }}
            className={
              hasValueInErrorMessage(xErrorMsg)
                ? "align-items-center"
                : "align-items-start"
            }
          >
            {/* <Grid item xs={3} sm={2} md={4}  >
              <CmpTypographyField xcomponent={"span"} xText={"Transfer Type"} />
            </Grid> */}
            <Grid item xs={6} sm={4} md={6}>
              <CmpSelectFieldV1
                xSize="small"
                xtabIndex={"1"}
                xLabelText="Doc.Type"
                xValue={vRdxWmsHead.A_VocTyp}
                xOnChange={fonSelectedGrnType}
                xName={"A_VocTyp"}
                xData={sDocLoadingGrnType}
                xValueMember={""}
                xDispalyMember={""}
                xError={xErrorMsg.A_VocTyp === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocTyp}
                xDisable={
                  xDisableBasedOnGridDataLength || vRdxWmsHead.A_VocNo != 0
                }
                // xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpTextFieldV1
                xLabelText="Doc.No"
                xSize="small"
                xValue={vRdxWmsHead.A_VocNo}
                xType={"text"} // text/number/password
                xName={"A_VocNo"}
                xReadOnly={true}
                xOnChange={""}
                xError={xErrorMsg.A_VocNo === "" ? false : true}
                xErrorMessage={xErrorMsg.A_VocNo}
                xOnKeyUp={xKey}
              />
            </Grid>

            <Grid item xs={6} sm={4} md={6}>
              <CmpDatePickerField001V1
                xtabIndex={"2"}
                xLabelText="Ref.Date"
                xValue={vRdxWmsHead.A_RefDt}
                xOnChange={fInvDate}
                xName={"A_RefDt"}
                xError={xErrorMsg.A_RefDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_RefDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>
            <Grid item xs={6} sm={4} md={6}>
              <CmpDatePickerField001V1
                xtabIndex={"2"}
                xLabelText="Doc.Date"
                xValue={vRdxWmsHead.A_PostDt}
                xOnChange={fPostDt}
                xName={"A_PostDt"}
                xError={xErrorMsg.A_PostDt === "" ? false : true}
                xErrorMessage={xErrorMsg.A_PostDt}
                // xOnKeyUp={(e) => {
                //   xFocusInput("Paymode");
                // }}
                xDisable={xDisableBasedOnGridDataLength}
              />
            </Grid>

           
          </Grid>
        </Grid>
        {!headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <Grid
              container
              spacing={0.9}
              columnSpacing={{ xs: 0.9, sm: 0.9, md: 1 }}
              columns={{ xs: 12, sm: 12, md: 12 }}
              className={
                hasValueInErrorMessage(xErrorMsg)
                  ? "align-items-center"
                  : "align-items-start"
              }
            >
              <Grid item xs={6} sm={4} md={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"14"}
                  xLabelText="Type"
                  xValue={vRdxWmsHead.TransferType}
                  xOnChange={fTransferType}
                  xName={"TransferType"}
                  xData={sTransferType}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.TransferType === "" ? false : true}
                  xErrorMessage={xErrorMsg.TransferType}
                  xDisable={xDisableBasedOnGridDataLength}
                />
              </Grid>

              <Grid item xs={6} sm={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"5"}
                  xLabelText="From Loc"
                  xValue={vRdxWmsHead.A_FromLoc}
                  xOnChange={fFromLocation}
                  xName={"A_FromLoc"}
                  xData={sFromLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_FromLoc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_FromLoc}
                  xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                />
              </Grid>
              

              <Grid item xs={6} sm={4}>
                <CmpSelectFieldV1
                  xSize="small"
                  xtabIndex={"5"}
                  xLabelText="To Loc"
                  xValue={vRdxWmsHead.A_ToLoc}
                  xOnChange={fToLocation}
                  xName={"A_ToLoc"}
                  xData={sToLocation}
                  xValueMember={""}
                  xDispalyMember={""}
                  xError={xErrorMsg.A_ToLoc === "" ? false : true}
                  xErrorMessage={xErrorMsg.A_ToLoc}
                  xDisable={xDisableBasedOnGridDataLength || sBufferItmCd}
                />
              </Grid>
              
            </Grid>
          </Grid>
        )}
        {headGridShow && (
          <Grid item xs={12} sm={12} md={7} lg={7}>
            <div style={{ height: "150px", width: "100%" }}>
              <DataGrid
                rowHeight={30}
                headerHeight={40}
                getRowClassName={(params) =>
                  params.indexRelativeToCurrentPage % 2 === 0
                    ? "mui-even-row"
                    : "mui-odd-row"
                }
                sx={{
                  border: 1,
                  borderColor: "primary.light",
                }}
                rows={sHeadGridRow}
                columns={sHeadGridColumn}
                onRowClick={() => {}}
                hideFooter={sHeadGridRow.length < 100}
                // components={{
                //   Toolbar: GridToolbar,
                // }}
              />
            </div>
          </Grid>
        )}
      </Grid>
    </form>
  );
}
